import { render, staticRenderFns } from "./CommentsInput.vue?vue&type=template&id=3d3809ec&"
import script from "./CommentsInput.vue?vue&type=script&lang=ts&"
export * from "./CommentsInput.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsInput.vue?vue&type=style&index=0&id=3d3809ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports